import { ReactNode } from "react";
import { Calendar, Users, Lightbulb, FileText, Plus } from "lucide-react";
import Button from "./Button";

interface EmptyStateProps {
  icon: "calendar" | "users" | "lightbulb" | "file";
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

const icons: Record<string, ReactNode> = {
  calendar: <Calendar className="w-10 h-10 text-slate-400" />,
  users: <Users className="w-10 h-10 text-slate-400" />,
  lightbulb: <Lightbulb className="w-10 h-10 text-slate-400" />,
  file: <FileText className="w-10 h-10 text-slate-400" />,
};

export default function EmptyState({
  icon,
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-6 text-center bg-white rounded-xl border border-slate-200 shadow-sm">
      <div className="w-20 h-20 bg-slate-100 rounded-2xl flex items-center justify-center mb-6">
        {icons[icon]}
      </div>
      
      <h3 className="text-xl font-semibold text-slate-900 mb-2">{title}</h3>
      <p className="text-slate-500 max-w-md mb-8 leading-relaxed">{description}</p>
      
      {actionLabel && onAction && (
        <Button onClick={onAction} icon={<Plus className="w-4 h-4" />} size="lg">
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
